import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from './config';
import BootScene from './scenes/BootScene';
import MenuScene from './scenes/MenuScene';
import QuestScene from './scenes/QuestScene';
import LineRiderScene from './scenes/LineRiderScene';

new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'app',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#101423',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [BootScene, MenuScene, QuestScene, LineRiderScene],
});
